module.exports = __webpack_public_path__ + "static/media/vi.9b32e9ea.svg";